import React from 'react';

import { Box } from '@mui/material';

import type { LensIntent, LensScopeBlockPayload } from '~/types/leData';

import LensQuestionCards from './LensQuestionCards';

export type LensScopeBlockProps = {
  payload: LensScopeBlockPayload;
  live: boolean;
  /** True while a turn this block itself started is in flight; disables its own options only. */
  sending?: boolean;
  onSendTurn: (question: string, intent: LensIntent) => void;
  /** The reader's visible answer while `sending`, so the block can show it even after a remount. */
  answeredText?: string;
  answeredQuestionAnswer?: Extract<LensIntent, { kind: 'answer' }>['questionAnswer'];
};

export default function LensScopeBlock({
  answeredText,
  answeredQuestionAnswer,
  live,
  onSendTurn,
  payload,
  sending = false,
}: LensScopeBlockProps) {
  if (!payload.question) {
    return null;
  }
  const interactive = live && !sending;
  return (
    <Box aria-label="Lens scope decision" role="region">
      <LensQuestionCards
        key={payload.question.id}
        answeredText={sending || !live ? answeredText : undefined}
        answeredQuestionAnswer={answeredQuestionAnswer}
        interactive={interactive}
        onSendTurn={onSendTurn}
        payload={payload}
      />
    </Box>
  );
}
